var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "\\uC885\\uC774"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M53.21,16.36h177.04 c20.35,0,36.85,16.5,36.85,36.85v177.04c0,20.35-16.5,36.85-36.85,36.85H53.21c-20.35,0-36.85-16.5-36.85-36.85V53.21 C16.36,32.86,32.86,16.36,53.21,16.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uAE00\\uC528"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    d: "M66.76,144.18h-6.13 c-0.78,0-1.42-0.63-1.42-1.42v-6.13c0-0.78,0.63-1.42,1.42-1.42h6.13c0.78,0,1.42,0.63,1.42,1.42v6.13 C68.18,143.55,67.55,144.18,66.76,144.18z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 98.09,
    y1: 76.13,
    x2: 224.47,
    y2: 76.13
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 98.09,
    y1: 209.55,
    x2: 224.47,
    y2: 209.55
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 98.09,
    y1: 139.7,
    x2: 224.47,
    y2: 139.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    d: "M66.76,214.03h-6.13 c-0.78,0-1.42-0.63-1.42-1.42v-6.13c0-0.78,0.63-1.42,1.42-1.42h6.13c0.78,0,1.42,0.63,1.42,1.42v6.13 C68.18,213.4,67.55,214.03,66.76,214.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    d: "M66.76,80.61h-6.13 c-0.78,0-1.42-0.63-1.42-1.42v-6.13c0-0.78,0.63-1.42,1.42-1.42h6.13c0.78,0,1.42,0.63,1.42,1.42v6.13 C68.18,79.97,67.55,80.61,66.76,80.61z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.942f0918ecdbc6883c34c3ba7be27cdf.svg";
export { ForwardRef as ReactComponent };